import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { ActivityMediumLink } from '@/components/activities/ActivityMediumLink';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconEmail from '@/icons/Email.svg';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const PendingValidationNotifiedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'pending_validation_notified'>;
}) => {
  const { view } = useRequestContext();

  const creatorName = activity.creator?.name;
  const canSeeClientPrice = !!view?.organizationPrice.shown;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconEmail />}
      message={
        <BaseActivityText>
          {creatorName ? (
            <Trans id="activities.pending_validation_notified.message">
              <strong>{creatorName}</strong> sent an email reminder about the quote to the client
            </Trans>
          ) : (
            <Trans id="activities.pending_validation_notified.message-no-creator">
              The quote has been sent by email to the client
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      {activity.medium && canSeeClientPrice && <ActivityMediumLink medium={activity.medium} />}
    </BaseActivity>
  );
};
